import { successConstants, successNameSpace} from "../constants/cardRequests.constants";

const initialState = {
  loading: false,
  success: false,
  request: null,
  response: null,
  error: null
};

export const sendSuccessCardsReducer = (state = initialState, action) => {
  switch (action.type) {
    case successConstants[`POST_${successNameSpace}_REQUEST`]:
      return {
        ...state,
        loading: true,
        request: action.request
      };
    case successConstants[`POST_${successNameSpace}_SUCCESS`]:
      return {
        ...state,
        loading: false,
        success: true,
        response: action.response,
        error: null
      };
    case successConstants[`POST_${successNameSpace}_FAILURE`]:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error
      };
    case successConstants[`POST_${successNameSpace}_RESET`]:
      return {
        loading: false,
        success: false,
        request: null,
        response: null,
        error: null
      };
    default:
      return state;
  }
};
